import dynamic from 'next/dynamic';

const DynamicFreemiumDialog = dynamic(() => import('@components/dialogs/FreemiumDialog'), {
    ssr: false,
});

export default DynamicFreemiumDialog;
